import React from 'react';
import { Truck } from 'lucide-react';

import one_pote from '../../images/one_pote_pricing.png'
import two_pote from '../../images/two_pote_pricing.png'
import three_pote from '../../images/three_pote_pricing.png'
import four_pote from '../../images/four_pote_pricing.png'

import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingSubheading,
  PricingContainer,
  PricingCard,
  DestaqueBadge,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  DiscountBadge,
  PriceBlock,
  PricingCardCost,
  FreeShippingBadge,
  BuyButton,
  PricingCardSubCost
} from './Pricing.elements';


const kits = [
  {
    img: one_pote,
    plano: '1 POTE',
    parcelas: '9X',
    valorParcela: 'R$ 6,23',
    aVista: 'R$ 46,82',
    link: '/form-compra?kit=1-pote&preco=46.82&description=Kit%20com%201%20pote%20de%20Pr%C3%B3-F%C3%ADgado',
    state: { kit: '1 POTE', preco: '46,82' }
  },
  {
    img: two_pote,
    plano: '2 POTES',
    desconto: '5% DE DESCONTO',
    parcelas: '12X',
    valorParcela: 'R$ 9,05',
    aVista: 'R$ 88,96',
    link: '/form-compra?kit=2-potes&preco=88.96&description=Kit%20com%202%20potes%20de%20Pr%C3%B3-F%C3%ADgado',
    state: { kit: '2 POTES', preco: '88,96' }
  },
  {
    img: three_pote,
    plano: '3 POTES',
    desconto: '7% DE DESCONTO',
    parcelas: '12X',
    valorParcela: 'R$ 13,29',
    aVista: 'R$ 130,63',
    link: '/form-compra?kit=3-potes&preco=130.63&description=Kit%20com%203%20potes%20de%20Pr%C3%B3-F%C3%ADgado',
    state: { kit: '3 POTES', preco: '130,63' }
  },
  {
    img: four_pote,
    plano: '4 POTES',
    desconto: '10% DE DESCONTO',
    destaque: 'MAIS ECONÔMICO',
    parcelas: '12X',
    valorParcela: 'R$ 17,15',
    aVista: 'R$ 168,55',
    link: '/form-compra?kit=4-potes&preco=168.55&description=Kit%20com%204%20potes%20de%20Pr%C3%B3-F%C3%ADgado',
    state: { kit: '4 POTES', preco: '168,55' }
  }
];


const FreeShipping = () => (
  <FreeShippingBadge>
    <Truck size={16} />
    FRETE GRÁTIS
  </FreeShippingBadge>
);

const Pricing = () => {
  return (
    <PricingSection id="pricing">
      <PricingWrapper>

        <PricingHeading>Escolha o KIT IDEAL para o seu tratamento</PricingHeading>
        <PricingSubheading>Frete grátis em todos os kits · Garantia de 7 dias</PricingSubheading>

        <PricingContainer>
          {kits.map(kit => (
            <PricingCard key={kit.plano} $destaque={Boolean(kit.destaque)}>
              {kit.destaque && <DestaqueBadge>{kit.destaque}</DestaqueBadge>}

              <PricingCardInfo>

                <PricingCardIcon>
                  <img src={kit.img} alt={`${kit.plano.toLowerCase()} Pró-Fígado`} />
                </PricingCardIcon>

                <PricingCardPlan>{kit.plano}</PricingCardPlan>
                {kit.desconto && <DiscountBadge>{kit.desconto}</DiscountBadge>}

                <PriceBlock>
                  <PricingCardSubCost>POR {kit.parcelas} DE</PricingCardSubCost>
                  <PricingCardCost>{kit.valorParcela}</PricingCardCost>
                  <PricingCardSubCost>OU <b>{kit.aVista}</b> À VISTA</PricingCardSubCost>
                </PriceBlock>

                <FreeShipping />

                <BuyButton to={kit.link} state={kit.state}>
                  Comprar
                </BuyButton>

              </PricingCardInfo>
            </PricingCard>
          ))}
        </PricingContainer>
      </PricingWrapper>
    </PricingSection>
  );
};

export default Pricing;
